import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API = Axios.getInstance
const API_FORMDATA = Axios.getInstanceForFormData

export const getAllBoardMember = (orgId) => {
    const params = { orgId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_BOARD_MEMBER, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const createBoardMember = (loginId, data) => {
    const params = { loginId }

    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_BOARD_MEMBER, data, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}
